import { useEffect, useRef } from "react";

import { useClassActions } from "../class-utils";
import { REACTION_ANIMATION_DURATION, REMOVE_REACTION_DELAY } from "../reactions";

import { useAppSelector } from "store/index";
import {
  selectCurrentClassUserId,
  selectCurrentClassUserReaction,
} from "store/selectors/class-user";

export const useAutoClearReaction = () => {
  const currentClassUserId = useAppSelector(selectCurrentClassUserId);
  const currentClassUserReaction = useAppSelector(selectCurrentClassUserReaction);
  const { toggleReaction } = useClassActions();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!currentClassUserReaction || !currentClassUserId) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      toggleReaction(null);
    }, REACTION_ANIMATION_DURATION + REMOVE_REACTION_DELAY);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [currentClassUserReaction, currentClassUserId, toggleReaction]);
};
